import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'


export default defineNuxtRouteMiddleware((to, from) => {
    if (useRuntimeConfig().public.websiteId !== 'spm' || !to.name) {
        return;
    }
    const routeName = to.name.split('_')[0];
    if (!routeName || ![
        'login',
        'logout',
        'register',
        'reset-password-code',
        'index',
        'trade-sell',
        'trade-review',
        'trade-sell-review',
        'trade-complete',
        'trade-sell-complete',
        'profile',
        'profile-addresses',
        'profile-watchlist',
        'profile-invoices',
        'profile-ledger',
        'profile-sell-orders',
        'profile-reseller',
        'profile-subaccounts',
        'subaccounts-completed',
        'subaccounts-expired',
    ].includes(routeName)) {
        throw createError({ statusCode: 404, statusMessage: 'Page not found' });
    }
})
